import { createContext } from "react";

export const MenueContext = createContext({});
